module.exports = __webpack_public_path__ + "static/media/cash.73230331.png";